import axios, { AxiosError, AxiosRequestConfig } from "axios";
import { useNavigate } from "react-router-dom";
import { User } from "../models/api";

  export interface ErrorResponse {
    
      errors: {
        message: string;
      }[];
   
  }

  export interface SuccessResponse<T> {
    message: string;
    data: T;
    code: number;
    successful: boolean;
  }


// export const BASEURL = 'https://good-gold-perch-belt.cyclic.app'
export const BASEURL = process.env.REACT_APP_BASE_URL

const api = axios.create({
  // Set your API base URL and other configurations
  baseURL: BASEURL,
  withCredentials: true
});

export const useAxiosInterceptor = () => {
  const navigate = useNavigate();
  const setupInterceptors = () => {
    // Request interceptor
    api.interceptors.request.use((config) => {
      const user = localStorage.getItem("user");
      if (user) {
        const {state}:{state:{user:User}} = JSON.parse(user);
        config.headers.Authorization = `Bearer ${state?.user?.accessToken || ''}`;
      }
      return config;
    });

    // Response interceptor
    api.interceptors.response.use(
      (response) => response,
      (error: AxiosError<ErrorResponse>) => {
        if (error.response && error.response.status === 401) {
          // Token expired or unauthorized
          return api
          .post(`${BASEURL}/auth/refresh-token`, null, {
            withCredentials: true,
          })
          .then((response) => {
            const { accessToken } = response.data.data;
            const userState = JSON.parse(
              localStorage.getItem("user") || "{}"
            ) as { state: { user: User } };

            localStorage.setItem(
              "user",
              JSON.stringify({
                ...userState,
                state: {
                  user: {
                    ...userState.state.user,
                    accessToken,
                  },
                },
              })
            );

            // Retry the original request with the new token
            if (error.config) {
              const originalConfig = error.config as AxiosRequestConfig;
              originalConfig.headers = {
                ...originalConfig.headers,
                Authorization: `Bearer ${accessToken}`,
              };
              return api(originalConfig);
            }
          })
          .catch(() => {
            logout(); // Refresh token failed, logout the user
          });
      
        }
        return Promise.reject(error);
      }
    );
  };

  const logout = async () => {
    // Clear token and redirect to login page
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("user");
    await api.post(`${BASEURL}/auth/logout`, null, { withCredentials: true });
    navigate("/login");
  };

  return {
    api,
    setupInterceptors,
    logout,
  };
};
